import Accordion from "accordion-js";
import { ACCORDION_SELECTOR } from "./utils";

const accordionClasses = {
  elementClass: "js-accordion-item",
  triggerClass: "js-accordion-trigger",
  panelClass: "js-accordion-panel",
};

const initAccordions = () => {
  $(ACCORDION_SELECTOR + "--facets").each(function () {
    if (this.accordion) return;

    this.accordion = new Accordion(this, {
      ...accordionClasses,
      duration: 400,
      showMultiple: true,
    });
  });

  $(ACCORDION_SELECTOR + "--ingredients").each(function () {
    if (this.accordion) return;

    this.accordion = new Accordion(this, {
      ...accordionClasses,
      duration: 400,
      showMultiple: true,
      openOnInit: this.hasAttribute("data-opened") ? [0] : [],
    });
  });

  $(ACCORDION_SELECTOR + "--how-to-use").each(function () {
    if (this.accordion) return;

    this.accordion = new Accordion(this, {
      ...accordionClasses,
      duration: 300,
      openOnInit: [0],
    });
  });

  $(ACCORDION_SELECTOR + "--obp").each(function () {
    if (this.accordion) return;

    this.accordion = new Accordion(this, {
      ...accordionClasses,
      duration: 300,
      openOnInit: this.hasAttribute("data-opened") ? [0] : [],
    });
  });

  $(ACCORDION_SELECTOR + "--skin-type").each(function () {
    if (this.accordion) return;

    this.accordion = new Accordion(this, {
      ...accordionClasses,
      duration: 300,
      openOnInit: this.hasAttribute("data-opened") ? [0] : [],
    });
  });

  $(ACCORDION_SELECTOR + "--skin-concern").each(function () {
    if (this.accordion) return;

    this.accordion = new Accordion(this, {
      ...accordionClasses,
      duration: 300,
      openOnInit: this.hasAttribute("data-opened") ? [0] : [],
    });
  });

  $(ACCORDION_SELECTOR + "--skin-consult").each(function () {
    if (this.accordion) return;

    this.accordion = new Accordion(this, {
      ...accordionClasses,
      duration: 300,
      openOnInit: this.hasAttribute("data-opened") ? [0] : [],
    });
  });

};

initAccordions();

$(window).on("shopify:section:load", function (e) {
  $(e.target).find(ACCORDION_SELECTOR) && initAccordions();
});
